import { GLOBAL_API_ERROR_CODES } from '@data/global-api-errors';
import type { GlobalApiErrorCode } from '@data/global-api-errors';
import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

import { CANCELLATION_REASONS } from '../../global.constants';
import type { CancellationReason } from '../../global.types';

export const LOGIN_VIEW_NAME = 'Login view';
export const LOGIN_VIEW_SELECT_DISABLED_REASON_ID =
  'login-view-select-disabled-reason';

export const LOGIN_VIEW_CANCELLATION_REASONS =
  CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS
    ? ([
        CANCELLATION_REASONS.doNotRememberMyBankLoginCredentials,
        CANCELLATION_REASONS.other,
      ] as const satisfies CancellationReason[])
    : ([
        CANCELLATION_REASONS.wantToPayAnotherWay,
        CANCELLATION_REASONS.doNotRememberMyBankLoginCredentials,
        CANCELLATION_REASONS.other,
      ] as const satisfies CancellationReason[]);

export const HANDLED_ERRORS: GlobalApiErrorCode[] = [
  GLOBAL_API_ERROR_CODES.CODE_409.CONFLICT,
  GLOBAL_API_ERROR_CODES.CODE_409.IDEMPOTENCY_CONFLICT,
  GLOBAL_API_ERROR_CODES.CODE_409.RESOURCE_NOT_MODIFIABLE,
  GLOBAL_API_ERROR_CODES.CODE_422.VALIDATION_FAILURE,
  GLOBAL_API_ERROR_CODES.CODE_424.FAILED_DEPENDENCY,
  GLOBAL_API_ERROR_CODES.CODE_424.RETRY_LIMIT_EXCEEDED,
  GLOBAL_API_ERROR_CODES.CODE_424.UNAUTHORISED,
];
